import styled from '@emotion/styled';
import { Palette } from '@updater/ui-uds';

export const TableRow = styled.tr`
  :nth-of-type(odd) {
    background: ${Palette.gray100};
  }
  height: 60px;
`;
